import { useAtomValue, WritableAtom, SetStateAction } from 'jotai';
import { useAuth } from 'src/auth/hooks/useAuth';
import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';

export const useAccountRefs = ({
  cslAccountAtom,
}: {
  cslAccountAtom: WritableAtom<(string | null)[], [SetStateAction<(string | null)[]>], void>;
}) => {
  const { user } = useAuth();
  const isCSLUser = useIsCslUser();

  const accountRef = useAtomValue(cslAccountAtom);

  return isCSLUser ? accountRef : [user.referenceId];
};
